import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div class="footer">
      <p>&copy; {currentYear} Glass Octopus. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;